<template>
  <div
    style=" position: relative; border-radius: 50%"
    class="crew-icon"
    v-b-tooltip:title="this.name"
  >
    <img
      :src="pp ? pp : 'resources/images/avatars/avatar-2.png'"
      width="100%"
      height="100%"
      style="border-radius: 50%;"
    />
    <span
      v-if="!pp"
      style="position: absolute; bottom: 0px; left: 0%; right: 0; text-align:center;font-weight: bold; color: #575757"
    >
      {{ initialName }}
    </span>
  </div>
</template>

<script>
export default {
  name: "crew-icon",
  props: {
    pp: {},
    name: {
      type: String
    }
  },
  computed: {
    initialName() {
      if (this.name) {
        let arr = this.name.split(" ");
        return `${arr[0][0]}${arr[1] ? arr[1][0] : ""}`;
      }
      return "";
    }
  }
};
</script>

<style scoped>
.crew-icon:hover {
  border: 4px solid #575757;
}
</style>
